'use client';

import { useCookieConsentStore } from '@onbeam/utils';
import { footerLinkStyles } from './Footer.styles';

export const ConsentModalButton = () => {
  const open = useCookieConsentStore((store) => store.openConsentModal);

  return (
    <button type="button" className={footerLinkStyles} onClick={open}>
      Cookies
    </button>
  );
};
